export const ACR = {
    MFA: 'http://schemas.openid.net/pape/policies/2007/06/multi-factor',
};

export const CHANGE_TYPE = {
    DELETE_ACCOUNT: 'delete_account',
    CHANGE_PASSWORD: 'change_password',
    ADD_MFA: 'add_mfa',
    DELETE_MFA: 'delete_mfa',
    EMAIL: 'email',
    PHONE: 'phone',
};